export const MAX_INPUT = 99;
export const MIN_INPUT = 1;
export const CSRF_TOKEN = $("meta[name='csrf-token']").attr("content");
